'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$PlanCode$() {
  this.c8p = null;
  this.c8q = false;
  this.c8n = null;
  this.c8o = false;
  this.c8l = null;
  this.Yw = null;
  this.c8m = null;
  $n_Lpresto_types$PlanCode$ = this;
  this.c8l = ($m_Lpresto_types$PlanCode$(), "default");
  this.Yw = ($m_Lpresto_types$PlanCode$(), "freemium_2fa");
  this.c8m = ($m_Lpresto_types$PlanCode$(), "presto_sign");
}
export { $c_Lpresto_types$PlanCode$ as $c_Lpresto_types$PlanCode$ };
$p = $c_Lpresto_types$PlanCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$PlanCode$;
/** @constructor */
function $h_Lpresto_types$PlanCode$() {
}
export { $h_Lpresto_types$PlanCode$ as $h_Lpresto_types$PlanCode$ };
$h_Lpresto_types$PlanCode$.prototype = $p;
$p.cIh = (function() {
  if ((!this.c8q)) {
    this.c8p = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c8q = true;
  }
  return this.c8p;
});
$p.adv = (function() {
  if ((!this.c8o)) {
    this.c8n = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c8o = true;
  }
  return this.c8n;
});
var $d_Lpresto_types$PlanCode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$PlanCode$, "presto.types$PlanCode$", ({
  a0L: 1,
  D: 1
}));
export { $d_Lpresto_types$PlanCode$ as $d_Lpresto_types$PlanCode$ };
var $n_Lpresto_types$PlanCode$;
function $m_Lpresto_types$PlanCode$() {
  if ((!$n_Lpresto_types$PlanCode$)) {
    $n_Lpresto_types$PlanCode$ = new $c_Lpresto_types$PlanCode$();
  }
  return $n_Lpresto_types$PlanCode$;
}
export { $m_Lpresto_types$PlanCode$ as $m_Lpresto_types$PlanCode$ };
//# sourceMappingURL=presto.types$-Plan-Code$.js.map
